module.exports = __webpack_public_path__ + "assets/1e95f20be56f323b3b4cd812e43e6426.png";